import { render, staticRenderFns } from "./EmptyRouterView.vue?vue&type=template&id=76374a81&scoped=true&"
import script from "./EmptyRouterView.ts?vue&type=script&lang=ts&"
export * from "./EmptyRouterView.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76374a81",
  null
  
)

export default component.exports